import { useState } from 'react';
import formatDateTimeUK from '@/helpers/formatDateTimeUK';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';

const PatientsList = ({ patients, handleRowClick }) => {
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	if (!patients) {
		return (
			<Box sx={{ width: '100%' }}>
				<h2>Patients medical records</h2>
				<p>You don't have any patients yet</p>
			</Box>
		);
	}

	const renderTable = () => {
		return (
			<Box sx={{ width: '100%' }}>
				<Paper sx={{ width: '100%', mb: 2 }}>
					<TableContainer style={{ overflowX: 'auto', width: '100%', overflowY: 'auto' }}>
						<Table
							sx={{ minWidth: 2000 }}
							className="table table-hover table-center mb-0"
							aria-label="simple table"
						>
							<TableHead>
								<TableRow>
									<TableCell style={{ width: '30px', padding: '0.25rem' }}>#</TableCell>
									{/* <th>Patient ID</th> */}
									{/* <th>User ID</th> */}
									<TableCell>First Name</TableCell>
									<TableCell>Last Name</TableCell>
									<TableCell>Gender</TableCell>
									<TableCell>Date of Birth</TableCell>
									<TableCell>Email Address</TableCell>
									<TableCell>Contact Number</TableCell>
									<TableCell>Address</TableCell>
									<TableCell>Company</TableCell>
									<TableCell>Occupation</TableCell>
									{/* <th>Channel ID</th> */}
									{/* <th>Marketing Subscription</th> */}
									{/* <th>Terms Consent</th> */}
									{/* <th>Group ID</th> */}
									{/* <th>Placeholder Column</th> */}
									<TableCell>Created On</TableCell>
									{/* <th>Updated At</th> */}
								</TableRow>
							</TableHead>
							<TableBody>
								{patients
									?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
									.map((patient, index) => (
										<TableRow
											key={patient.record_id || index}
											onClick={() => handleRowClick(patient.record_id)}
											style={{ cursor: 'pointer' }}
										>
											<TableCell>{index + 1}</TableCell>
											{/* <td>{patient.record_id}</td> */}
											{/* <td>{patient.user_id}</td> */}
											<TableCell>{patient.first_name}</TableCell>
											<TableCell>{patient.last_name}</TableCell>
											<TableCell>{patient.gender}</TableCell>
											<TableCell>{formatDateTimeUK(patient.date_of_birth)}</TableCell>
											<TableCell>{patient.email_address}</TableCell>
											<TableCell>{patient.contact_number}</TableCell>
											<TableCell>{patient.address}</TableCell>
											<TableCell>{patient.company}</TableCell>
											<TableCell>{patient.occupation}</TableCell>
											{/* <td>{patient.channel_id}</td> */}
											{/* <td>{patient.marketing_subscription}</td> */}
											{/* <td>{patient.terms_consent}</td> */}
											{/* <td>{patient.group_id}</td> */}
											{/* <td>{patient.placeholder_column}</td> */}
											<TableCell>{formatDateTimeUK(patient.created_at)}</TableCell>
											{/* <td>{patient.updated_at}</td> */}
										</TableRow>
									))}
							</TableBody>
						</Table>
					</TableContainer>
					<TablePagination
						rowsPerPageOptions={[5, 10, 25]}
						component="div"
						count={patients.length}
						rowsPerPage={rowsPerPage}
						page={page}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
					/>
				</Paper>
			</Box>
		);
	};

	return (
		<div className="card border-0">
			<h2>Patients Records</h2>
			{/* <div className="card card-table mb-0">
                <div className="card-body"> */}
			{renderTable()}
			{/* </div> */}
			{/* </div> */}
		</div>
	);
};

export default PatientsList;
